const PLUS = /\+/g;
const HYPHEN = /-/g;
const SLASH = /\//g;
const UNDERSCORE = /_/g;
const EQUALS = /=/g;

export function encode(value: string): string {
  return btoa(value).replace(PLUS, '-').replace(SLASH, '_').replace(EQUALS, '');
}

export function decode(value: string): string {
  return atob(value.replace(HYPHEN, '+').replace(UNDERSCORE, '/'));
}
